export const txtTitle = "The EV Panel"
export const txtSubtitle = "Welcome to the"